import { watchImmediate } from "@vueuse/core"
import { toRef } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"

interface Props {
	title: string
}

const PageTitle: ReactiveComponent<Props> = (props) => {
	watchImmediate(toRef(props, "title"), (newTitle) => (document.title = `${newTitle} | Decider Skills`))
	return () => {props.title}
}
export default defineComponent(PageTitle, inferProps<Props>())
